import React from 'react';
import { MetricsElement } from 'react-metrics';

import QuickFilter from '@hpstellar/core/QuickFilter';
import { SelectedCategory } from '../../filters/components/select-categories';

import '../css/vwa-quick-filters.less';

const clickHandler = (updateFilterUrl, filterString) => () => updateFilterUrl(filterString);

export default React.memo(({ useAlias = true }) => {
    return (
        <SelectedCategory useAlias={useAlias}>
            {({ selectedCategory, updateFilterUrl, seralizedQuery }) => {
                const { quickFilters } = selectedCategory || {};
                const filter = (seralizedQuery || '').split('/').pop();
                if (!quickFilters || !quickFilters.length) {
                    return null;
                }

                return (
                    <div className="quick-filters">
                        <p>APPLY QUICK FILTERS</p>
                        <div className='quick-filter-container'>
                            {quickFilters.map(f => (
                                <MetricsElement
                                    element='span'
                                    data-metrics-event-name="searchFilter"
                                    data-metrics-event="e_facet"
                                    data-metrics-filter-checked={true}
                                    data-metrics-filter-categories='quick'
                                    data-metrics-filter-value={f.displayName.toLowerCase().replace(/\s+/gi, '')}
                                >
                                    {/* // TODO: verify quickfilters */}
                                    <QuickFilter
                                        key={f.displayName}
                                        onClick={clickHandler(updateFilterUrl, f.filterQuery)}
                                        active={filter === f.filterQuery}
                                    >
                                        {f.displayName}
                                    </QuickFilter>
                                </MetricsElement>
                            ))}
                        </div>
                    </div>
                );
            }}
        </SelectedCategory>
    );
});
